// *********************************************************
// Copyright (c) 2017 Agra Technologies Pvt. Ltd.. All rights reserved
// *********************************************************
import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { UserService } from './user.service';
import { DeviceDetectorService } from 'ngx-device-detector';
@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  redirectUrl: string = '';
  queryParams: any = {};
  constructor(
    private userService: UserService,
    private router: Router,
    private deviceDetector: DeviceDetectorService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let url: string = state.url;
    let isUserLoggedIn = this.checkLogin(url);
    if (url != '/') {
      localStorage.setItem('redirectUrl', state.url);
    } else {
      if (isUserLoggedIn) {
        this.redirectUrl = '/dashboard';
        // if (this.userService.getUserFunctions().includes(2) && this.deviceDetector.isMobile()) {
        //   this.redirectUrl = '/accounts';
        // }
        // else {
        //   this.redirectUrl = '/dashboard';
        // }
        this.router.navigate([this.redirectUrl], {
          queryParams: this.queryParams,
        });
      }
    }
    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {
    if (this.userService.isLoggedIn()) {
      return true;
    }

    // Store the attempted URL for redirecting
    this.userService.redirectUrl = url;

    // Navigate to the login page with extras
    this.router.navigate(['/signin']);
    return false;
  }
}
